<template>
  <div>
    <div class="handle-box">
      <el-form ref="searchform" :model="searchform" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="出库单号" prop="outBillCode">
              <el-input v-model="searchform.outBillCode" style="width:100%" clearable></el-input>
            </el-form-item>
          </el-col>
                     <el-col :span="6">
            <el-form-item label="包装级别" prop="awardObject">
              <el-select v-model="searchform.packageLevel" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in packageLevellist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品编码" prop="productCode">
              <el-input v-model="searchform.productCode" style="width:100%" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="批次号" prop="bacthNo">
              <el-input v-model="searchform.bacthNo" style="width:100%" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="1">
            <el-button @click="resetForm('searchform')">重置</el-button>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <br />
    <el-row type="flex" class="row-bg">
      <el-col :span="24" class="border">
        <h4>促销政策列表-已配置</h4>
        <el-divider></el-divider>
        <el-table
          border
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          :data="tableData"
          style="width:100%;"
        >
          <el-table-column prop="outbillAssigned.outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.batchNo" label="批次号" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.outbillCount" label="出库数量" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.productName" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.productCode" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column
                  prop="awardType"
                  label="奖励类型"
                  min-width="100"
                  show-overflow-tooltip
                ></el-table-column>
          <el-table-column prop="outbillAssigned.dealerName" label="经销商名称" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.address" label="经销商地址" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="assignStatename" label="状态" min-width="150" show-overflow-tooltip></el-table-column>
        </el-table>
        <br />
        <el-pagination
          background
          @current-change="currentchange"
          @size-change="pagesize"
          :current-page.sync="currentPage"
          :page-sizes="[10,20,30,50]"
          layout="total,prev, pager, next,jumper,sizes"
          :total="total_count"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { updatestate, findByConditions } from "@/api/market/marketing";
//引入导出组件模块
export default {
    props: {
    packdate: {
      type: Function,
      default: null
    },
  },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      multipleSelection: [],
      activeName: "first",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      packageLevellist: [
        {
          value: 1,
          label: "一级包装"
        },
        {
          value:2,
          label: "二级包装"
        },
      ],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        datelist: [],
        outBillCode: null,
        packageLevel:1,
        productCode: null,
        bacthNo: null,
        state: 2,
        page: 1,
        pageSize: 10
      },
      // 待审核模块对象
      second: {}
    };
  },
  methods: {
    next() {
      // 步骤条
      this.show = !this.show;
      if (this.active++ >= 2) {
        this.active = 1;
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findByConditions(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata(this.searchform);
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    }
  }
};
</script>
<style scoped>
</style>